// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rig-detail-panel {
  padding: 1rem;
  height: 100%;
}
.rig-detail-panel h3 {
  margin-bottom: 1rem;
}
.rig-detail-panel .content {
  padding: 1rem;
  margin-bottom: 1rem;
}
.rig-detail-panel .field-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}
.rig-detail-panel .field-label {
  flex: 0 0 130px;
  margin: 0;
}
.rig-detail-panel .field-value {
  flex: 1 1 auto;
  min-width: 0;
}
.rig-detail-panel .no-selection {
  color: var(--p-text-muted-color, #888);
  padding-top: 16px;
}
.rig-detail-panel .rig-form {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.rig-detail-panel .rig-form .general-error {
  color: var(--mat-form-field-error-text-color, #f44336);
  font-size: 0.85em;
}
.rig-detail-panel .rig-form .form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}
.rig-detail-panel .rig-form .form-actions .btn-spinner {
  display: inline-block;
  margin-right: 6px;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/rigs/rig-detail/rig-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AADJ;AAIE;EACE,eAAA;EACA,SAAA;AAFJ;AAKE;EACE,cAAA;EACA,YAAA;AAHJ;AAME;EACE,sCAAA;EACA,iBAAA;AAJJ;AAOE;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AALJ;AAOI;EACE,sDAAA;EACA,iBAAA;AALN;AAQI;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AANN;AAQM;EACE,qBAAA;EACA,iBAAA;EACA,sBAAA;AANR","sourcesContent":[".rig-detail-panel {\n  padding: 1rem;\n  height: 100%;\n\n  h3 {\n    margin-bottom: 1rem;\n  }\n\n  .content {\n    padding: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .field-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 10px;\n  }\n\n  .field-label {\n    flex: 0 0 130px;\n    margin: 0;\n  }\n\n  .field-value {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .no-selection {\n    color: var(--p-text-muted-color, #888);\n    padding-top: 16px;\n  }\n\n  .rig-form {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n\n    .general-error {\n      color: var(--mat-form-field-error-text-color, #f44336);\n      font-size: 0.85em;\n    }\n\n    .form-actions {\n      display: flex;\n      justify-content: flex-end;\n      margin-top: 0.5rem;\n\n      .btn-spinner {\n        display: inline-block;\n        margin-right: 6px;\n        vertical-align: middle;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
